import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface EditIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Edit icon using SF Pro font symbol (􀈎)
 *
 * This icon represents edit/modify actions in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <EditIcon />
 * <EditIcon size={16} weight="semibold" />
 * ```
 */
export const EditIcon = React.forwardRef<HTMLSpanElement, EditIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀈎" {...props} />
  }
)

EditIcon.displayName = "EditIcon"
